<template>
  <div class="fixed-info-block">
    <div class="fixed-image-block">
      <div class="fixed-image-block-overlay">
        <div class="fixed-block-title image-title">
          Got a project in mind?
        </div>
        <p>We are very interested to hear more about your project!</p>
        <router-link
          :to="{name: 'RequestQuote'}"
          class="link learn-more white"
        >
          Request a quote
        </router-link>
      </div>
    </div>
    <div class="fixed-content-block contact">
      <div class="fixed-block-title">
        Contact us
      </div>
      <ul class="w-list-unstyled contact-us-list">
        <li class="contact-us-list-item">
          <img
            src="/images/Icon-megaphone.png"
            class="contact-us-icon"
          >
          <div class="contact-us-text">
            <strong>Call us</strong>:&nbsp;
            <a
              class="link"
              href="tel:8774117627"
            >
              +1(877)&nbsp;411-ROAR&nbsp;(7627)
            </a>
          </div>
        </li>
        <!-- <li class="contact-us-list-item"><img
          src="/images/Icon-skype.png"
          class="contact-us-icon">
          <div class="contact-us-text"><strong>Skype</strong>: gravity.agency</div>
        </li> -->
        <li class="contact-us-list-item last">
          <img
            src="/images/Icon-mail.png"
            class="contact-us-icon"
          >
          <div class="contact-us-text">
            <strong>Mail</strong>:
            <a
              class="link"
              href="mailto:info@roaringsky.com"
            >
              info@roaringsky.com
            </a>
          </div>
        </li>
      </ul>
    </div>
    <div class="fixed-content-block">
      <!-- <div class="fixed-block-title">Job opening!</div>
      <p>We are currently looking for a creative Graphic Designer.&nbsp;</p>
      <router-link
        href="404.html"
        class="link learn-more">Learn more</router-link> -->
    </div>
  </div>
</template>

<script>
export default {}
</script>
